import React, { useEffect, useState } from "react";
import {
  Placements,
  Avatar,
  Button,
  StatusTags,
  Backdrop,
  LogoLoader,
  TableAdv,
} from "../../../../components";
import { mapTableRows } from "../../../../utils/mapTableRows";
import generateVendors from "../../../../assets/data/generateVendor";

import { vendorData } from "../../../../assets/data/candidatesData";
import { dateFormator } from "../../../../utils/dateFormator";
import { useDispatch, useSelector } from "react-redux";
import {
  clearVendorData,
  getVendorsStart,
} from "../../../../redux/slices/vendor/vendorSlice";
import { Link } from "react-router-dom";
import { getVendorId } from "../../../../utils/getClientId";
import { usePagination } from "../../../../hooks";

// const newCandidatesData = vendorData.map((item, index) => ({
//   id: index + 1,
//   ...item,
// }));

const VendorsWithActiveConsultants = () => {
  const [searchValue, setSearchValue] = useState("");
  const dispatch = useDispatch();
  const { loading, error, vendors, totalCount } = useSelector(
    (state) => state.vendor
  );

  const isLoading = loading;

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      dispatch(
        getVendorsStart({
          page: newPage,
          limit: newLimit,
          filters: {
            "placements.0": { type: "EXISTS", value: 1 },
            search: { type: "SEARCH", value: searchValue },
          },
          sort: { uiid: -1 },
          ret: "uiid businessName generalInfo.recordStatus generalInfo.netTerms  consultants",
          ref: "PlacementWithEmp",
          incl: "employeeId jobInfo.startDate jobInfo.endDate jobInfo.jobTitle",
        })
      );
    }
  );

  const tableData = vendors?.data || []; // Add null check with default empty array
  console.log("tableData", tableData);

  const handleEdit = (row) => {
    alert(row.slno);
  };

  const columns = [
    {
      key: "businessName",
      label: "Business Name",
      render: (row) => (
        <Link to="/vendor/vendor-details" state={{ code: row.uiid }}>
          <div className="flex items-center gap-2">
            <Avatar
              alt={row.businessName}
              size="sm"
              outline
              src={row.profileImage}
            />
            {row.businessName}
          </div>
        </Link>
      ),
    },
    {
      key: "vendorId",
      label: "Vendor ID",
      render: (row) => (
        <div className="flex items-center gap-1 text-linkblue">
          <Link to="/vendor/vendor-details" state={{ code: row.uiid }}>
            {getVendorId(row.uiid)}
          </Link>
          {/* <span className="text-linkblue">{row.uiid}</span> */}
        </div>
      ),
    },

    {
      key: "netTerms",
      label: "Net Terms",
      render: (row) => (
        <Link to="/vendor/vendor-details" state={{ code: row.uiid }}>
          <div className="flex items-center gap-1">
            <span className="">{row?.generalInfo?.netTerms}</span>
          </div>
        </Link>
      ),
    },
    {
      key: "vendorStatus",
      label: "Vendor Status",
      render: (row) => (
        <Link to="/vendor/vendor-details" state={{ code: row.uiid }}>
          <StatusTags
            tag={
              row.generalInfo?.recordStatus === 1
                ? "Active"
                : row.generalInfo?.recordStatus === 2
                ? "Inactive"
                : 0
            }
          />
        </Link>
      ),
    },
    // { key: "contactNo", label: "Contact No" },
    // {
    //   key: "emailId",
    //   label: "Email ID",
    //   render: (row) => (
    //     <div className="flex items-center gap-1">
    //       <span className="text-linkblue">{row.emailId}</span>
    //     </div>
    //   ),
    // },
    {
      key: "activePlacements",
      label: "Active Placements",
      //name(fn + ln) email jobtitle phone joiningdate
      render: (row) => (
        // from sir - not ready due to its not mapped
        <Placements
          // data={row.consultants
          //   ?.filter((placement) => {
          //     const endDate = new Date(placement?.jobInfo?.endDate);
          //     const today = new Date();
          //     return !placement?.jobInfo?.endDate || endDate >= today;
          //   })
          //   .map((place) => ({
          //     name:
          //       place?.employeeId?.firstName +
          //         " " +
          //         place?.employeeId?.lastName || "-",
          //     email: place?.employeeId?.email?.primary || "-",
          //     jobtitle: place?.jobInfo?.jobTitle || "-",
          //     phone: place?.employeeId?.mobile?.primary?.number || "-",
          //     joiningDate: dateFormator(place?.jobInfo?.startDate) || "-",
          //   }))}
          data={Array.from(
            new Map(
              row.consultants
                ?.filter((placement) => {
                  const endDate = new Date(placement?.jobInfo?.endDate);
                  const today = new Date();
                  return !placement?.jobInfo?.endDate || endDate >= today;
                })
                .map((place) => [
                  place.uiid,
                  {
                    name:
                      place?.employeeId?.firstName +
                        " " +
                        place?.employeeId?.lastName || "-",
                    email: place?.employeeId?.email?.primary || "-",
                    jobtitle: place?.jobInfo?.jobTitle || "-",
                    phone: place?.employeeId?.mobile?.primary?.number || "-",
                    joiningDate: dateFormator(place?.jobInfo?.startDate) || "-",
                  },
                ])
            ).values()
          )}
          columnData={[
            // "id",
            // {
            //   key: "joiningDate",
            //   label: "Joining Date",
            //   render: (row) => dateFormator(row.joiningDate, "short"),
            // },
            {
              key: "name",
              label: "Name",
            },
            {
              key: "email",
              label: "Email",
            },
            {
              key: "jobtitle",
              label: "Job Title",
            },
            {
              key: "phone",
              label: "Phone",
            },
            {
              key: "joiningDate",
              label: "Joining Date",
            },
          ]}
          modalTitle="Active Placements"
        />
      ),
    },

    {
      key: "",
      label: "Action",
      render: (row) => (
        <Button
          type="icon"
          variant="text"
          icon="filter_alt"
          size="sm"
          color="black"
          onClick={() => handleEdit(row)}
        />
      ),
      sortable: false,
    },
  ];

  const mappedRows = mapTableRows(tableData, columns);

  useEffect(() => {
    dispatch(
      getVendorsStart({
        limit,
        page,
        filters: {
          "consultants.0": { type: "EXISTS", value: 1 },
          search: { type: "SEARCH", value: searchValue },
        },
        sort: { uiid: -1 },
        ret: "uiid businessName generalInfo.recordStatus generalInfo.netTerms  consultants",
        ref: "PlacementWithEmp",
        incl: "employeeId jobInfo.startDate jobInfo.endDate jobInfo.jobTitle",
      })
    );
    return () => {
      dispatch(clearVendorData());
    };
  }, [dispatch, page, limit, searchValue]); // Empty array will cause it to run once when the component mounts

  const handleSearch = (keyname, value) => {
    setSearchValue(value);
  };

  return (
    <div className="flex flex-col overflow-hidden">
      <TableAdv
        tableId={`vendors_vendorswithactiveconsultants`}
        rows={mappedRows}
        columns={columns}
        showSlNo
        //
        serverPagination={true}
        totalCount={totalCount?.data}
        page={page}
        limit={limit}
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
        serverSerchValue={searchValue}
        serverOnSearch={handleSearch}
        toolbarRight={{
          search:true,
          filter:true,
          download:true
        }}
      />
      <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>{" "}
    </div>
  );
};

export default VendorsWithActiveConsultants;
